__turbopack_context__.v({
  "dropzone": "O94CYq_dropzone",
});
